import {Backdrop, CircularProgress, Box} from '@mui/material';

import {orangeColors} from '../../layouts/theme/designSystem';

interface LoadingProps {
  backDrop?: boolean;
}

export const Loading = ({backDrop}: LoadingProps) => {
  const spinner = (
    <CircularProgress
      data-testid='loading'
      sx={{
        color: orangeColors[70],
      }}
    />
  );

  return backDrop ? (
    <Backdrop
      data-testid='backdrop'
      open={true}
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1000,
      }}
    >
      {spinner}
    </Backdrop>
  ) : (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      {spinner}
    </Box>
  );
};
